<template>
    <sitemap-section
        class="sitemap-section-module"
        :sections="attributes.asyncData.sections"
    />
</template>

<script>
    import SitemapSection from '../../../organisms/SitemapSection/SitemapSection';

    export default {
        name: 'sitemap-section-module',

        components: { SitemapSection },

        props: {
            attributes: {
                type: Object,
                default: () => ({}),
            },
        },

        async asyncData({ $strapi }) {
            const { default: sitemapQuery } = await import('../../../../queries/sitemap/sitemap.graphql');

            const data = await $strapi.query(sitemapQuery);

            const sections = (data.sitemapSections || [])
                .filter((section) => section.pages.length)
                .map((section) => ({
                    title: section.title,
                    pages: (section.pages || []).map((page) => ({
                        title: page.title,
                        uri: page.uri,
                    })),
                }));

            return {
                sections,
            };
        },
    };
</script>
